import { MonoTypeOperatorFunction } from 'rxjs';
import { distinctUntilChanged } from 'rxjs/operators';

/**
 * Will ignore updates from the stream until they are different from the previous value using a deep comparison
 */
export function distinctUntilValueChanged<T>(): MonoTypeOperatorFunction<T> {
  return distinctUntilChanged((prev, current) => JSON.stringify(prev) === JSON.stringify(current));
}
